import app from '@/main'
import Vue from 'vue'
import { setTouristsVal, getTouristsVal, getTouristsUserId } from '@/utils'
import { get, post } from '@/utils/ajax'
import * as Sentry from '@sentry/browser'

export default {
  async logout({ commit }) {
    try {
      await Vue.prototype.$auth('logout')
    } catch (e) {
      console.error(e)
    }
    commit('LOGOUT')
  },
  // 获取站点信息进行全局的判断
  async getInitSiteMsg({ state, commit }, id = 0) {
    let url = `${CONFIG.edu_test}/${location.href.split('/')[3]}`
    url = url.includes('?isCpp') ? url.split('?')[0] : url
    const res = await post(
      '/home/sites/user/info',
      { url, userId: id },
      { ignoreToken: true }
    )
    // 设置全局变量判断是否需要登录
    setTouristsVal(!res.loginEnabled)
    commit('SET_SITE_MSG', res)
    return res
  },
  // 游客模式设置用户id
  async getTouristsId({ state, commit }, newId) {
    const tourists = { id: newId }
    localStorage.setItem('user_id', newId)
    commit('SET_USER', tourists)
    return tourists
  },
  // 获取c端的用户信息
  async getCodemaoUserInfo({ state, commit }) {
    const isTourists = getTouristsVal()
    const _id = getTouristsUserId()
    if (isTourists) {
      const tourists = { id: _id || -99 }
      localStorage.setItem('user_id', _id || -99)
      commit('SET_USER', tourists)
      return tourists
    }
    const user = await app.$auth('get_profile')
    localStorage.setItem('user_id', user.id)
    Sentry.setTag('account_id', user.id)
    commit('SET_USER', user)
    commit('HAS_TOKEN', true)
    return state.user
  },
  // 获取c端的用户信息(私密信息)
  async getCodemaoAuthUserInfo({ state, commit }) {
    const user = await app.$auth('get_auth')
    user.phone = user.phone_number
    commit('SET_USER', user)
    return state.user
  },
  // 验证码初始化
  async sdkInit({ commit, state }, newPid) {
    if (!state.CodemaoCaptcha) {
      const captcha = await Vue.prototype.$sdk.getCaptchaInstance('captcha', {
        pid: newPid || 'egLIJPgY'
      })
      commit('SETSTATE', {
        key: 'CodemaoCaptcha',
        value: captcha
      })
      return captcha
    }
  },
  // 调用验证码
  async getCaptchaInit({ state, commit, dispatch }, newPid) {
    await dispatch('sdkInit', newPid)
    const captcha = await state.CodemaoCaptcha.get_captcha({
      identity: state.phoneNum,
      dom_id: 'countdownBtn',
      success_callback: async (ticket) => {
        try {
          await Vue.prototype.$auth(
            state.captchaType,
            state.phoneNum,
            ticket,
            newPid || 'egLIJPgY'
          )
          Vue.prototype.$message.success('验证码已发送')
          commit('SETSTATE', { key: 'captchaCb', value: 'lock' })
        } catch (error) {
          commit('SETSTATE', { key: 'captchaCb', value: 'reset' })
        }
      },
      fail_callback: (err) => {
        console.error('验证码报错警告：', err)
      }
    })
    commit('SETSTATE', { key: 'captcha', value: captcha })
    await captcha.init()
  },
  async getUserInfo({ state, commit }) {
    try {
      let classUserInfo = await get(
        `/home/edu/examinees/${state.user.id}/profile`
      )
      classUserInfo = {
        ...classUserInfo,
        account: localStorage.currentAccount,
        avatar_url: state.user.avatar_url,
        name: state.user.fullname
      }
      commit('SETSTATE', { key: 'classUserInfo', value: classUserInfo })
    } catch (error) {
      console.log(error)
    }
  },
  // 考试信息
  async getTestInfo({ state, commit, dispatch }, ignoreMsg = true) {
    if (!state.user.id) {
      await dispatch('getCodemaoUserInfo')
    }
    let testInfo = {}
    if (!localStorage.examId) {
      testInfo = {
        account: localStorage.currentAccount,
        avatar_url: state.user.avatar_url,
        // name: state.user.fullname,
        name: '',
        identity_num: '',
        start: false // 标记在当前站点是否有考试
      }
      commit('SETSTATE', { key: 'testInfo', value: testInfo })
      // if (show) commit('SETSTATE', { key: 'showTestModal', value: true })
      return
    }
    try {
      testInfo = await get(
        `/home/exams/${localStorage.examId}/examinees/${state.user.id}/profile`,
        {},
        { ignoreMsg }
      )
      testInfo.avatar_url = state.user.avatar_url
      testInfo.account = localStorage.currentAccount
      // testInfo.name = state.user.fullname
      testInfo.start = true
      testInfo.isLate = await dispatch('judgeLate', testInfo)
      // console.log('isLate', testInfo.isLate)
      testInfo.exam_id = localStorage.examId
      localStorage.examineeId = testInfo.examinee_id
      commit('SET_EXAMINEE_INFO', testInfo)
    } catch (e) {
      localStorage.examineeId = 0
      testInfo = {
        account: localStorage.currentAccount,
        avatar_url: state.user.avatar_url,
        // name: state.user.fullname,
        name: '',
        identity_num: '',
        start: false
      }
    }
    commit('SETSTATE', { key: 'testInfo', value: testInfo })
    // if (show) commit('SETSTATE', { key: 'showTestModal', value: true })
  },
  // 获取考试配置
  async getTestConfig({ commit }) {
    const queryExamId = new URLSearchParams(location.search).get('examId')
    if (queryExamId) {
      localStorage.setItem('examId', queryExamId)
    }

    const examId = localStorage.getItem('examId')
    if (!examId) {
      return
    }
    try {
      const { exam_config, identity_verification, exam_type } = await get(
        `/home/exams/check/${examId}`
      )
      const config = {
        cameraOption: [],
        identityVerification: identity_verification,
        examType: exam_type
      }
      exam_config.forEach(({ label, actual_value }) => {
        const key = label.split('#')[1]
        if (actual_value === '1') {
          config.cameraOption.push(key)
        }
        config[key] = isNaN(actual_value) ? actual_value : +actual_value
      })
      commit('SETSTATE', { key: 'testConfig', value: config })
    } catch (error) {}
  },
  async judgeLate({ state, commit, dispatch }, testInfo) {
    if (!testInfo.last_come_in_minute) return false
    // 当前时间 <= 最迟入场时间 且 考生还没进入考试
    // examinee_status考生考试状态 (0:未开始, 1:考试中且未答题, 2:考试中且已答题, 3:考试中且已答所有题, 4:已交卷, 5:考试结束, 6: 缺考, 7:批改中，8：已批改
    const nowTime = await get('/home/common/times')
    return (
      nowTime - testInfo.start_time >=
        testInfo.last_come_in_minute * 60 * 1000 &&
      testInfo.examinee_status === 0
    )
  },
  // 考试监控埋点
  async setMonitorReport({ state, commit, dispatch }, data) {
    const isTourists = getTouristsVal()
    if (isTourists) return
    // type - 监控类型  1: 进入身份核验； 2: 进入考试须知；3: 进入候考 4：开始答题
    const userId = Number(localStorage.getItem('user_id'))
    const examId = Number(localStorage.getItem('examId'))
    const params = {
      type: data.type,
      userId: userId,
      examId: examId
    }
    await post(`/home/exam_monitors`, params)
  },
  async getProvinceList({ commit, state }, id) {
    if (state.areaList.length) return state.areaList
    const res = await get(`/home/edu/location/provinces`)
    commit('SET_PROVENCE_DATA', {
      data: res
    })
    return res
  },
  async getCityList({ commit, state }, id) {
    let nodes = []
    const exist = state.areaList.some((v1) => {
      if (v1.id === id && v1.children.length) {
        nodes = v1.children
      }
      return v1.id === id && v1.children.length
    })
    if (exist) return nodes
    const res = await get(`/home/edu/location/provinces/${id}/cities`)
    commit('SET_CITY_DATA', {
      id: id,
      data: res
    })
    return res
  },
  async getDistrict({ commit, state }, id) {
    let nodes = []
    const exist = state.areaList.some((v1) => {
      return v1.children.some((v2) => {
        if (v2.id === id && v2.children.length) {
          nodes = v2.children
        }
        return v2.id === id && v2.children.length
      })
    })
    if (exist) return nodes
    const res = await get(`/home/edu/location/cities/${id}/districts`)
    commit('SET_DISISTRICT_DATA', {
      id: id,
      data: res
    })
    return res
  },
  async getQiniuToken({ commit, state }) {
    const isTourists = getTouristsVal()
    let ticket = ''
    if (isTourists) {
      // 敏捷测评
      const res = await get(`/home/oss/qiniu/issue`)
      if (res && res.ticket) {
        ticket = res.ticket
      }
    } else {
      // 非敏捷测评
      const res = await get(`/home/oss/qiniu/tokens/uploading`)
      if (res && res.tokens) {
        ticket = res.tokens[0].token
      }
    }
    window.sessionStorage.setItem('QINIUTOKEN', ticket)
  }
}
